import { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { Box } from "@mui/material";
import moment from "moment";
import { ResType } from "types";
import { useQuery } from "react-query";
import { snack } from "components/toast";
import {
  getExcelFyaEvents,
  getExcelResponseDueEvents,
  getTracesIssueEvents,
} from "api/services/automation/dashboard-tan";
import { useNavigate } from "react-router-dom";
import EventIndication from "views/calendar/EventIndication";
import useTitle from "hooks/useTitle";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import ViewEvent from "./ViewEvent";

const AtomProTanCalendar = () => {
  useTitle("ATOM Pro | Calendar");
  const { permissions } = usePermissions();
  const [initialDate, setInitialDate] = useState<any>(moment().format("YYYY-MM-DD").toString());
  const [currentEvents, setCurrentEvents] = useState([]);
  const [firstRender, setFirstRender] = useState(true);
  const [viewOpen, setViewOpen] = useState(false);
  const [data, setData] = useState({});

  // const { data: fyaData, isLoading: fyaLoading }: ResType = useQuery(
  //   ["events", { startDates: initialDate }],
  //   getFyaEvents,
  //   {
  //     onError: (err) => {
  //       if (!err?.error) {
  //         snack.error(`An error occurred while fetching notice events`);
  //       }
  //     },
  //     enabled:
  //       permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //       permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
  //   }
  // );

  // const { data: responseDue, isLoading: responseDueIsLoading }: ResType = useQuery(
  //   ["response-due-events", { startDates: initialDate }],
  //   getResponseDueEvents,
  //   {
  //     enabled:
  //       permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //       permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
  //   }
  // );

  const { data: excelFyaData, isLoading: excelFyaLoading }: ResType = useQuery(
    ["tan-excel-events", { startDates: initialDate }],
    getExcelFyaEvents,
    {
      onError: (err) => {
        if (!err?.error) {
          snack.error(`An error occurred while fetching notice events`);
        }
      },
    }
  );

  const { data: excelResponseDue, isLoading: excelResponseDueIsLoading }: ResType = useQuery(
    ["tan-excel-response-due-events", { startDates: initialDate }],
    getExcelResponseDueEvents
  );

  const { data: tracesIssueDate, isLoading: tracesIssueDateIsLoading }: ResType = useQuery(
    ["tan-traces-issue-events", { startDates: initialDate }],
    getTracesIssueEvents
  );

  useEffect(() => {
    const events: any = [
      // ...eventsData("event"),
      // ...responseDues("response"),
      ...excelEventsData("excel-event"),
      ...excelResponseDues("excel-response"),
      ...tracesIssueDates("traces-event"),
    ];
    setCurrentEvents(events);
  }, [tracesIssueDate, excelFyaData, excelResponseDue]);

  // const eventsData = (source) => {
  //   const currentDate = moment().format("YYYY-MM-DD");
  //   return (
  //     fyaData?.data?.map((item: any) => {
  //       const isEventBeforeCurrentDate = item?.issuedOn < currentDate;
  //       return {
  //         title: item?.proceedingName,
  //         date: moment(item?.issuedOn).format("YYYY-MM-DD"),
  //         backgroundColor: isEventBeforeCurrentDate ? "rgba(11, 128, 67, 0.5)" : "#0B8043",
  //         textColor: "white",
  //         id: `${source}-${item?.id}`,
  //         originalId: item?.id,
  //       };
  //     }) || []
  //   );
  // };

  // const responseDues = (source) => {
  //   const currentDate = moment().format("YYYY-MM-DD");
  //   const list =
  //     responseDue && responseDue?.data && responseDue?.data ? responseDue?.data : responseDue;

  //   return (
  //     list?.map((item: any) => {
  //       const isTaskBeforeCurrentDate = item?.responseDueDate < currentDate;

  //       return {
  //         title: `${item?.proceedingName}`,
  //         date: moment(item?.responseDueDate).format("YYYY-MM-DD"),
  //         backgroundColor: isTaskBeforeCurrentDate ? "rgba(142, 36, 170, 0.5)" : "#8E24AA",
  //         textColor: "white",
  //         id: `${source}-${item?.id}`,
  //         originalId: item?.id,
  //       };
  //     }) || []
  //   );
  // };

  const excelEventsData = (source) => {
    const currentDate = moment().format("YYYY-MM-DD");

    return (
      excelFyaData?.data?.map((item: any) => {
        const formattedNoticeDate = moment(item?.noticeSentDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        const isEventBeforeCurrentDate = formattedNoticeDate < currentDate;
        return {
          title: `${item?.proceedingName} (${item?.client?.displayName})`,
          date: formattedNoticeDate,
          backgroundColor: isEventBeforeCurrentDate ? "rgba(170, 36, 38, 0.5)" : "#AA2426",
          textColor: "white",
          id: `${source}-${item?.id}`,
          originalId: item?.id,
        };
      }) || []
    );
  };

  const excelResponseDues = (source) => {
    const currentDate = moment().format("YYYY-MM-DD");
    const list =
      excelResponseDue && excelResponseDue?.data && excelResponseDue?.data
        ? excelResponseDue?.data
        : excelResponseDue;

    return (
      list?.map((item: any) => {
        const formattedNoticeDate = moment(item?.dateOfCompliance, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        const isEventBeforeCurrentDate = formattedNoticeDate < currentDate;

        return {
          title: `${item?.proceedingName} (${item?.client?.displayName})`,
          date: formattedNoticeDate,
          backgroundColor: isEventBeforeCurrentDate ? "rgba(128, 170, 36, 0.5)" : "#80AA24",
          textColor: "white",
          id: `${source}-${item?.id}`,
          originalId: item?.id,
        };
      }) || []
    );
  };

  const tracesIssueDates = (source) => {
    const currentDate = moment().format("YYYY-MM-DD");
    const list =
      tracesIssueDate && tracesIssueDate?.data && tracesIssueDate?.data
        ? tracesIssueDate?.data
        : tracesIssueDate;

    return (
      list?.map((item: any) => {
        const formattedNoticeDate = moment(item?.date, "DD-MMM-YYYY").format("YYYY-MM-DD");
        const isEventBeforeCurrentDate = formattedNoticeDate < currentDate;
        return {
          title: `${item?.commCat} (${item?.client?.displayName})`,
          date: formattedNoticeDate,
          backgroundColor: isEventBeforeCurrentDate ? "#d7bde2" : "#884ea0 ",
          textColor: "#1b2631",
          id: `${source}-${item?.id}`,
          originalId: item?.id,
        };
      }) || []
    );
  };

  const navigate = useNavigate();
  const clickedevent = (value: any) => {
    let bgColor = value.event.backgroundColor;
    // if (bgColor === "#0B8043" || bgColor === "rgba(11, 128, 67, 0.5)") {
    //   // let event = fyaData?.data?.find(
    //   //   (item: any) => item.id === +value.event.extendedProps.originalId
    //   // );
    //   let event;
    //   if (event.type === "FYA") {
    //     navigate(`/atom-pro/income-tax/proceeding-action/notice-fya/${event?.id}`);
    //   } else {
    //     navigate(`/atom-pro/income-tax/proceeding-information/notice-fyi/${event?.id}`);
    //   }
    // }

    // if (bgColor === "#8E24AA" || bgColor === "rgba(142, 36, 170, 0.5)") {
    //   // let event = responseDue?.data?.find(
    //   //   (item: any) => item.id === +value.event.extendedProps.originalId
    //   // );
    //   let event;
    //   if (event.type === "FYA") {
    //     navigate(`/atom-pro/income-tax/proceeding-action/notice-fya/${event?.id}`);
    //   } else {
    //     navigate(`/atom-pro/income-tax/proceeding-information/notice-fyi/${event?.id}`);
    //   }
    // }

    if (bgColor === "#AA2426" || bgColor === "rgba(170, 36, 38, 0.5)") {
      let event = excelFyaData?.data?.find(
        (item) => item.id === +value.event.extendedProps.originalId
      );
      setViewOpen(true);
      setData({ ...event, calanderType: "e-Proceeding Excel Notice", date:event?.noticeSentDate });
    }

    if (bgColor === "#80AA24" || bgColor === "rgba(128, 170, 36, 0.5)") {
      let event = excelResponseDue?.data?.find(
        (item) => item.id === +value.event.extendedProps.originalId
      );
      setViewOpen(true);
      setData({ ...event, calanderType: "e-Proceeding Excel Notice", date: event?.dateOfCompliance });
    }

    if (bgColor === "#d7bde2" || bgColor === "#884ea0") {
      let event = tracesIssueDate?.data?.find(
        (item) => item.id === +value.event.extendedProps.originalId
      );
      setViewOpen(true);
      setData({ ...event, calanderType: "Traces Notice", date: event?.date });
    }
  };

  function getFirstDayOfMonthInRange(startDate, endDate) {
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      if (currentDate.getDate() === 1) {
        const aa = moment(currentDate).format("YYYY-MM-DD").toString();
        return aa;
      }
      currentDate.setMonth(currentDate.getMonth() + 1);
      currentDate.setDate(1);
    }
    return new Date();
  }
  const handleDatesSet = (info: any) => {
    if (firstRender) {
      setFirstRender(false);
    } else {
      if (info?.view?.type === "dayGridMonth") {
        setInitialDate(getFirstDayOfMonthInRange(info.start, info.end));
      } else {
        setInitialDate(moment(info?.start).format("YYYY-MM-DD").toString());
      }
    }
  };

  const eventIndicationClicked = (bgcolor: any) => {
    const events: any = [
      // ...eventsData("event"),
      // ...responseDues("response"),
      ...excelEventsData("excel-event"),
      ...excelResponseDues("excel-response"),
      ...tracesIssueDates("traces-event"),
    ];
    let filteredevents = events;
    if (bgcolor === "#3F51B5") {
      filteredevents = events.filter(
        (item: any) =>
          item.backgroundColor === bgcolor || item.backgroundColor === "rgba(63, 81, 181, 0.5)"
      );
    } else if (bgcolor === "#0B8043") {
      filteredevents = events.filter(
        (item: any) =>
          item.backgroundColor === bgcolor || item.backgroundColor === "rgba(11, 128, 67, 0.5)"
      );
    } else if (bgcolor === "#8E24AA") {
      filteredevents = events.filter(
        (item: any) =>
          item.backgroundColor === bgcolor || item.backgroundColor === "rgba(142, 36, 170, 0.5)"
      );
    } else if (bgcolor === "#AA2426") {
      filteredevents = events.filter(
        (item: any) =>
          item.backgroundColor === bgcolor || item.backgroundColor === "rgba(170, 36, 38, 0.5)"
      );
    } else if (bgcolor === "#80AA24") {
      filteredevents = events.filter(
        (item: any) =>
          item.backgroundColor === bgcolor || item.backgroundColor === "rgba(128, 170, 36, 0.5)"
      );
    } else if (bgcolor === "#884ea0") {
      filteredevents = events.filter(
        (item: any) => item.backgroundColor === bgcolor || item.backgroundColor === "#d7bde2"
      );
    }
    // filteredevents = events.filter((item: any) => item.backgroundColor === bgcolor);
    setCurrentEvents(bgcolor == "" ? events : filteredevents);
  };

  // if (
  //   !(
  //     permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //     permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  //   )
  // ) {
  //   return <AccessDenied />;
  // }

  return (
    <Box m={2}>
      <FullCalendar
        contentHeight="65vh"
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
        headerToolbar={{
          left: "today prev,next",
          center: "title",
          // right: "",
          right: "dayGridMonth,listMonth", // Added listMonth button
        }}
        eventClick={clickedevent}
        dayMaxEventRows={2}
        events={currentEvents}
        datesSet={(e) => handleDatesSet(e)}
        initialDate={moment(initialDate).format("YYYY-MM-DD")}
      />

      <Box
        sx={{
          display: "flex",
          gap: 2,
          mt: 2,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EventIndication onClick={() => eventIndicationClicked("")} color="#2C3E50" title="All" />
        {/* <EventIndication
          onClick={() => eventIndicationClicked("#8E24AA")}
          color="#8E24AA"
          title="Response Due Date"
        />
        <EventIndication
          onClick={() => eventIndicationClicked("#0B8043")}
          color="#0B8043"
          title="Issued On"
        /> */}
        <EventIndication
          onClick={() => eventIndicationClicked("#AA2426")}
          color="#AA2426"
          title="Excel Issued On"
        />
        <EventIndication
          onClick={() => eventIndicationClicked("#80AA24")}
          color="#80AA24"
          title="Excel Response Due Date"
        />
        <EventIndication
          onClick={() => eventIndicationClicked("#884ea0")}
          color="#884ea0"
          title="Traces Communication Issue Date"
        />
      </Box>
      <ViewEvent open={viewOpen} setOpen={setViewOpen} data={data} />
    </Box>
  );
};

export default AtomProTanCalendar;
